import { useGetPoisonQueues } from '@urbanx/agx.support.client';
import {
  AgxCheckbox,
  AgxColumn,
  AgxTable,
  AgxTypography,
  IColumnConfig,
} from '@urbanx/agx.ui-components2';
import Panel from 'components/panel/Panel';
import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SupportBackButton from '../SupportBackButton';

const tableColumns: (string | IColumnConfig)[] = [
  'Service',
  'Queue',
  { name: 'Number of Messages', align: 'right' },
];
const PoisonQueues = () => {
  const { data: poisonQueues, isPending: isPoisonQueuesPending } = useGetPoisonQueues();

  const [filterToQueuesWithMessages, setFilterToQueuesWithMessages] = useState(true);

  const navigate = useNavigate();

  const filteredPoisonQueues = useMemo(() => {
    return (
      (poisonQueues ?? [])
        .flatMap((pq) =>
          (pq.poisonQueues ?? []).map((queue) => ({
            service: pq.agxService,
            queue: queue.name,
            itemCount: queue.itemCount,
          }))
        )
        .filter(
          (queue) => !filterToQueuesWithMessages || (queue.itemCount && queue.itemCount > 0)
        ) ?? []
    );
  }, [poisonQueues, filterToQueuesWithMessages]);

  const rows = useMemo(() => {
    if (!filteredPoisonQueues) return [];

    return (
      filteredPoisonQueues.map((pq, idx) => ({
        Service: (
          <AgxTypography id={`poison-queue-${idx}-service`} type={'body_ui'} size={'small'}>
            {pq.service?.toString()}
          </AgxTypography>
        ),
        Queue: (
          <AgxTypography id={`poison-queue-${idx}-queue`} type={'body_ui'} size={'small'}>
            {pq.queue}
          </AgxTypography>
        ),
        'Number of Messages': (
          <AgxTypography id={`poison-queue-${idx}-queue`} type={'body_ui'} size={'small'}>
            {pq.itemCount}
          </AgxTypography>
        ),
      })) ?? []
    );
  }, [filteredPoisonQueues]);

  const onRowClick = useCallback(
    (rowIndex: number) => {
      const queue = filteredPoisonQueues[rowIndex];

      if (!queue?.service || !queue?.queue) return;

      navigate(
        `./${encodeURIComponent(queue.service.toString())}/${encodeURIComponent(queue.queue)}`
      );
    },
    [filteredPoisonQueues, navigate]
  );

  return (
    <AgxColumn gap="spacing-xl" fill>
      <SupportBackButton />
      <Panel title="Queues with errors">
        <AgxCheckbox
          id="filterPoisonQueuesCheckbox"
          checked={filterToQueuesWithMessages}
          onChange={() => setFilterToQueuesWithMessages(!filterToQueuesWithMessages)}
          label="Show only queues with messages"
        />
        <AgxTable
          columns={tableColumns}
          rows={rows}
          onRowClick={onRowClick}
          showLoadingState={isPoisonQueuesPending}
        />
      </Panel>
    </AgxColumn>
  );
};

export default PoisonQueues;
